<template>
  <div class="container-fluid">
    <panel Title="ثبت امضا" Des="لطفا رمز پایمک شده به نلفن همراه خود را در کادر زیر وارد کنید" :IsBtnBack="false" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row my-3">
      <div class="col-md-4 col-12 p-4"></div>
      <div id="CreateSign" class="col-md-4 col-12 p-4">
        <small>رمز پیامک شده:</small>
        <input v-model="DataAxiosAdd.password" type="text" class="form-control" />
      </div>
      <div class="col-md-4 col-12 p-4"></div>
      <div class="col-md-4 col-12 p-4"></div>
      <div class="col-md-4 col-12 p-4">
        <button @click="submitCreateSing" class="btn btn-success w-100">ثبت رمز</button>
      </div>
      <div class="col-md-4 col-12 p-4"></div>
    </div>
  </div>
</template>
<script>
import Panel from '../../Tools/NetPa/Panel.vue'
import Loading from '../../Tools/NetPa/Loading.vue'

export default {
  components: { Panel, Loading },
  props: ['IntroduceInfo'],
  data() {
    return {
      DataAxiosAdd: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('CustCode').codeMeli,
        },
        certificate_request_id: this.IntroduceInfo.ref_id,
        national_code: this.IntroduceInfo.national_code,
        password: '',
      },
    }
  },
  methods: {
    submitCreateSing() {
      if (this.$ValidForm('CreateSign')) {
        this.loadingRender = true
        var DataAxios = { Method: 'POST', Action: 'ElectronicSafte/IntroduceSign', ArryfildValue: this.DataAxiosAdd }
        this.$PostData(DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.loadingRender = false
              this.$mySweetDefaultTost('ثبت موفق اطلاعات', 'پیامکی حاوی رمز عبور برای شما ارسال شد', 'success', 2500)
              this.$emit('introduce_success', result.data)
            } else {
              this.loadingRender = false
              this.ErrorList = result.data
            }
          })
          .catch((error) => {
            this.loadingRender = false
            this.ErrorList = [{ message: 'مشکل ناشناخته دوباره تلاش کنید' }]
          })
      }
    },
  },
}
</script>
